<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="billing !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <!-- <button withRight="admin.billing.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu> -->
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'number'" [control]="form.get('number')" [type]="'input'" [label]="t('common.labels.number')" [edit]="inEdit" [basevalue]="package.number"></app-form-control>
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="package.name"></app-form-control>
        <app-form-control [cid]="'amount'" [control]="form.get('amount')" [type]="'input'" [label]="t('common.labels.amount')" [edit]="inEdit" [basevalue]="package.amount"></app-form-control>
        <app-form-control [cid]="'used'" [control]="form.get('used')" [type]="'input'" [label]="t('common.labels.used')" [edit]="inEdit" [basevalue]="package.used"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'status'" [control]="form.get('status')" [type]="'input'" [label]="t('common.labels.status')" [edit]="inEdit" [basevalue]="t('common.labels.' + package.status)"></app-form-control>
        <app-form-control [cid]="'price'" [control]="form.get('price')" [type]="'input'" [label]="t('common.labels.price')" [edit]="inEdit" [basevalue]="package.price | currency:'EUR':'symbol':'1.2-2':'de-DE' "></app-form-control>
        <app-form-control [cid]="'activated_at'" [control]="form.get('activated_at')" [type]="'input'" [label]="t('common.labels.activated_at')" [edit]="inEdit" [basevalue]="package.activated_at | amDateFormat: 'DD.MM.YYYY' "></app-form-control>
        <app-form-control [cid]="'finished_at'" [control]="form.get('finished_at')" [type]="'input'" [label]="t('common.labels.finished_at')" [edit]="inEdit" [basevalue]="package.finished_at | amDateFormat: 'DD.MM.YYYY'"></app-form-control>

      </div>
    </div>

  </form>
</ng-container>
